import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { SessionsService } from '~/services/SessionsService';

import { FORBIDDEN_ROUTE } from './routes';

const PrivateRoute: React.FC<Record<string, any>> = ({ component: Component, render, ...rest }) => (
  // Show the component only when the user is logged in
  // Otherwise, redirect the user to /login page
  <Route
    {...rest}
    render={
      props =>
        SessionsService.isAuthorized() ? render?.() || <Component {...props} /> : <Redirect to={FORBIDDEN_ROUTE()} />
      // Implement public route: /login or other public route
    }
  />
);

export default PrivateRoute;
